import { Env, LocaleDomainSuffixConfig } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import { ThirdPartyFlowUseCase } from '@shopee-user/business-customization-types';

export function getThirdPartyFlowTriggerUrl(params: {
  usecase: ThirdPartyFlowUseCase;
}): string {
  const { ENV, LOCALE } = config;
  const domainSuffix = LocaleDomainSuffixConfig[LOCALE];
  const envPrefix = getEnvPrefix(ENV);
  const baseUrl = `https://${envPrefix}spx.${domainSuffix}/spx-admin`;

  switch (params.usecase) {
    case ThirdPartyFlowUseCase.Login:
      return baseUrl;
    case ThirdPartyFlowUseCase.UserLinkage:
      return `${baseUrl}/account/profile`;
    default:
      return baseUrl;
  }
}

function getEnvPrefix(env: Env): string {
  switch (env) {
    case Env.Test:
      return 'test.';
    case Env.Uat:
      return 'uat.';
    case Env.Staging:
      return 'staging.';
    case Env.Live:
      return '';
    default:
      return '';
  }
}
